export default __webpack_public_path__ + "static/media/partnership.a5243932.svg";